import { HTMLAttributes, ReactNode } from 'react';
import { MainContainer } from './style';

interface MainProps extends HTMLAttributes<HTMLDivElement>{
    children: ReactNode;
}

const Main = ({ children, ...rest }: MainProps) => {
    return (
        <MainContainer {...rest}>{children}</MainContainer>
    );
}

export default Main;